import { useFormikContext } from 'formik';
import React, { useMemo } from 'react';
import { getFormErrors } from '../../../services/form/getFormErrors';
import { localise } from '../../../services/lang/lang';
import StandardFormSelect from '../../modules/Form/StandardFormSelect';
import { useTrackUnsavedChanges } from '../../modules/UnsavedChanges/useTrackUnsavedChanges';
import { RenderIf } from '../../modules/RenderIf/RenderIf';
import StandardFormInput from '../../modules/Form/StandardFormInput';
const RemoteSubmissionLocationInput = ({ locationTypes, locations, }) => {
    const { values, errors, dirty, setFieldValue, handleChange } = useFormikContext();
    useTrackUnsavedChanges(dirty);
    const locationGroups = [
        {
            label: 'New location',
            options: locationTypes,
            key: 'location_type_id',
        },
    ];
    const locationsWithType = useMemo(() => locations.map((location) => {
        const nameTheSame = location.type.name === location.name;
        return {
            ...location,
            name: nameTheSame
                ? location.name
                : `${location.name} - <light>${location.type.name}</light>`,
        };
    }), [locations]);
    if (locations.length) {
        locationGroups.unshift({
            label: 'Previously used location',
            options: locationsWithType,
            key: 'location_id',
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(StandardFormSelect, { onChange: (id, key) => {
                if (!key)
                    throw new Error('Key needs to be provided here');
                setFieldValue('locationSelection', { key, id });
            }, groups: locationGroups, nameField: "name", error: getFormErrors(errors, 'location'), label: "Choose a location", value: values.locationSelection }),
        React.createElement(RenderIf, { condition: values.locationSelection?.key === 'location_type_id' },
            React.createElement(StandardFormInput, { error: errors.location_name, value: values.location_name, placeholder: localise('LOCATION_NAME_PLACEHOLDER'), label: localise('LOCATION_NAME'), onChange: handleChange, name: "location_name", helpText: localise('LOCATION_HELP_TEXT') }))));
};
export default RemoteSubmissionLocationInput;
